import { ChapterDto, ChallengeDto, StepDto, LearningModuleDto } from "@api";
import { createSelector, DefaultProjectorFn, MemoizedSelector } from "@ngrx/store";
import { sortByName } from "src/app/utils/sort-by-name";
import { sortByOrder } from "src/app/utils/sort-by-order";
import { RootState } from "..";
import { LearningModuleState } from "./state";

const selectFeature = (state: RootState): LearningModuleState => state.learningModule;

export const selectLoading = createSelector(selectFeature, state => state.loading);

export const selectLearningModules = createSelector(selectFeature, state => Object.values(state.learningModules).sort(sortByName));

export const selectLearningModule = (
  moduleId: string,
): MemoizedSelector<RootState, LearningModuleDto, DefaultProjectorFn<LearningModuleDto>> =>
  createSelector(selectFeature, state => state.learningModules[moduleId]);

export const selectLearningModuleChapters = (
  moduleId: string,
): MemoizedSelector<RootState, ChapterDto[], DefaultProjectorFn<ChapterDto[]>> =>
  createSelector(selectFeature, state =>
    Object.values(state.chapters)
      .filter(chapter => chapter.learningModuleId === moduleId)
      .sort(sortByOrder),
  );

export const selectChapter = (chapterId: string): MemoizedSelector<RootState, ChapterDto, DefaultProjectorFn<ChapterDto>> =>
  createSelector(selectFeature, state => state.chapters[chapterId]);

export const selectChapterChallenges = (
  chapterId: string,
): MemoizedSelector<RootState, ChallengeDto[], DefaultProjectorFn<ChallengeDto[]>> =>
  createSelector(selectFeature, state =>
    Object.values(state.challenges)
      .filter(challenge => challenge.chapterId === chapterId)
      .sort(sortByOrder),
  );

export const selectChapterChallengesCount = (chapterId: string): MemoizedSelector<RootState, number, DefaultProjectorFn<number>> =>
  createSelector(selectFeature, state => state.chapterChallenges[chapterId]);

export const selectChallenge = (challengeId: string): MemoizedSelector<RootState, ChallengeDto, DefaultProjectorFn<ChallengeDto>> =>
  createSelector(selectFeature, state => state.challenges[challengeId]);

export const selectChallengeSteps = (challengeId: string): MemoizedSelector<RootState, StepDto[], DefaultProjectorFn<StepDto[]>> =>
  createSelector(selectFeature, state =>
    Object.values(state.steps)
      .filter(step => step.challengeId === challengeId)
      .sort(sortByOrder),
  );

export const selectChallengeStepsCount = (challengeId: string): MemoizedSelector<RootState, number, DefaultProjectorFn<number>> =>
  createSelector(selectFeature, state => state.challengeSteps[challengeId]);

export const selectStep = (stepId: string): MemoizedSelector<RootState, StepDto, DefaultProjectorFn<StepDto>> =>
  createSelector(selectFeature, state => state.steps[stepId]);
